interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "MAD";
};

const MAD: Currency = Object.freeze({
  "displayName": "Moroccan Dirham",
  "numericCode": 504,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": false,
  "symbolPosition": "before",
  "isoCode": "MAD",
  "symbol": "Dh"
});

export { MAD };
